// extracted by mini-css-extract-plugin
export default {"titleWrapper":"abhRQ92iQkbwaMSKau_Z","title":"SVy07PU716U22EgZbjDu","popupIcon":"p2kNjN1YWniIBmWFZU_A"};